export default __webpack_public_path__ + "static/media/f36826675a4a0363e721f63a08d48e76.png";